import React from 'react';
import { addClassNames } from '@goodfynd/theme';

import type { DashboardStickyFooterProps } from './types';

import classes from './DashboardStickyFooter.module.css';

export const DashboardStickyFooter = ({
  children,
  className,
  hidden,
}: DashboardStickyFooterProps) => {
  return (
    <div
      className={addClassNames(
        classes['sticky-footer'],
        {
          [classes.hidden]: hidden,
        },
        className
      )}
    >
      {children}
    </div>
  );
};
